import "./RegStepPlanOption.scss";
import ProStarFilledIcon from "../icons/ProStarFilledIcon";
import DesignPlanIcon from "../icons/DesignPlanIcon";
import { PlanLength, PlanType } from "../../util/types";
import { getPlanDescription, getPlanPrice, getPlanSubtitle } from "../../service/SubscriptionService";

interface Props {
  planType: PlanType;
  planLength: PlanLength;
  active?: boolean;
  onClick: () => void;
}

export default function RegStepPlanOption({ planType, planLength, active, onClick }: Props) {
  return <div
    className={`plan-option ${active ? "active" : ""} ${planType === "pro" ? "pro" : "design"} ${planLength === "monthly" ? "monthly" : "annual"}`}
    onClick={onClick}>
    <header>
      {planType === "pro" ? <ProStarFilledIcon /> : <DesignPlanIcon />}
      {planType === "pro" ? "Pro" : "Design"}
    </header>

    <section>
      <span className={"price"}>
        {getPlanPrice(planType, planLength)}
      </span>
      <span className={"subtitle"}>
        {getPlanSubtitle(planType, planLength)}
      </span>
      <span className={"description"}>
        {getPlanDescription(planType, planLength)}
      </span>
    </section>
  </div>;
}
